import styled from '@emotion/styled'
import React, { FC, useMemo } from 'react'
import FluidImage from './base/FluidImage'
import {
  PrismicRichTextProps,
  RichTextComponentConfig,
  LinkProps,
  ImageProps,
  PrismicRichText,
} from './PrismicRichText'

const DefaultComponent = styled.div({})

const Paragraph = styled.p({})

const Em = styled.span({
  fontStyle: 'italic',
})

const Strong = styled.span({
  fontWeight: 'bold',
})

const Link: FC<LinkProps> = ({ link, children }) => {
  return (
    <a href={link.url} target={link.target}>
      {children}
    </a>
  )
}

const Image: FC<ImageProps> = ({ image }) => {
  const aspect = image.dimensions.width / image.dimensions.height
  const fluidImage = useMemo(
    () => ({
      fluid: {
        src: image.url,
        srcSet: image.url,
        aspectRatio: aspect,
      },
    }),
    [image],
  )
  return <FluidImage image={fluidImage} lazy={true}></FluidImage>
}

const baseConfig: RichTextComponentConfig = {
  heading1: DefaultComponent,
  heading2: DefaultComponent,
  heading3: DefaultComponent,
  heading4: DefaultComponent,
  heading5: DefaultComponent,
  heading6: DefaultComponent,
  paragraph: Paragraph,
  preformatted: DefaultComponent,
  strong: Strong,
  em: Em,
  listItem: DefaultComponent,
  oListItem: DefaultComponent,
  list: DefaultComponent,
  oList: DefaultComponent,
  image: Image,
  embed: DefaultComponent,
  hyperlink: Link,
  label: DefaultComponent,
  span: DefaultComponent,
}

interface RichTextProps extends Omit<PrismicRichTextProps, 'config'> {
  config?: Partial<RichTextComponentConfig>
  className?: string
}

export const createRichTextComponent = (
  config: Partial<RichTextComponentConfig>,
) => {
  const startConfig = { ...baseConfig, ...config }
  return (props: RichTextProps) => {
    const finalConfig = useMemo(() => ({ ...startConfig, ...props.config }), [
      props.config,
    ])
    return (
      <RichTextContainer className={props.className}>
        <PrismicRichText {...props} config={finalConfig} />
      </RichTextContainer>
    )
  }
}

const RichTextContainer = styled('div')({})

const useWelcomeText = (componentConfig?: Partial<RichTextComponentConfig>) => {
  const WelcomeTextComponent = createRichTextComponent(
    componentConfig ? componentConfig : {},
  )

  return {
    welcomeTextComponent: (
      <WelcomeTextComponent
        blocks={[{ type: 'text', text: 'Welcome to Oda', spans: [] }]}
      />
    ),
  }
}

const SignatureImage = styled('img')<ImageProps>()

const { welcomeTextComponent } = useWelcomeText({
  image: SignatureImage,
})
